// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3gJKw","right":"styles_right__dxReI"};